import { none, Option, some } from 'fp-ts/lib/Option';
import { authActions, AuthActionsType } from 'state/auth/auth.actions';
import { getType } from 'typesafe-actions';

export interface AuthState {
  token: Option<string>;
  loading: boolean;
  error: Option<unknown>;
  username: Option<string | undefined>;
}

export const initialState: AuthState = {
  token: none,
  loading: false,
  error: none,
  username: none,
};

export function authReducer(state = initialState, action: AuthActionsType) {
  switch (action.type) {
    case getType(authActions.login):
      return {
        ...state,
        loading: true,
        error: none,
        token: state.token || none,
      };
    case getType(authActions.loginSuccess):
      return {
        ...state,
        loading: false,
        error: none,
        token: some(action.payload.token),
        username: some(action.payload.username),
      };
    case getType(authActions.loginError):
      return { ...state, loading: false, error: some(action.payload) };
    case getType(authActions.mfaLogin):
      return {
        ...state,
        loading: true,
        error: none,
        token: state.token || none,
      };
    case getType(authActions.mfaLoginSuccess):
      return {
        ...state,
        loading: false,
        error: none,
        token: some(action.payload.token),
        username: some(action.payload.username),
      };
    case getType(authActions.mfaLoginError):
      return { ...state, loading: false, error: some(action.payload) };
    case getType(authActions.logout):
      return { ...state, loading: true };
    case getType(authActions.logoutSuccess):
      return { ...state, loading: false, error: none, token: none };
    case getType(authActions.logoutError):
      return {
        ...state,
        loading: false,
        error: some(action.payload),
        token: none,
      };
    default:
      return state;
  }
}
